import SteakSandwichImage from 'images/mealCardGallery/BaconJalapenoPopperSteakSandwich.jpg';
import BrownSugarGlazedMeatloafImage from 'images/mealCardGallery/brown-sugar-glazed-meatloaf.jpg';
import ButternutSquashRisottoImage from 'images/mealCardGallery/ButternutSquashRisotto.jpg';
import CaribbeanStyleJerkTofuImage from 'images/mealCardGallery/CaribbeanStyleJerkTofu.jpg';
import ChickenAndVegetableFajitasImage from 'images/mealCardGallery/chicken-and-vegetable-fajitas.jpg';
import CreamyTomatoChickenImage from 'images/mealCardGallery/CreamySunDriedTomatoChicken.jpg';
import ShrimpAlfredoImage from 'images/mealCardGallery/FlorentineShrimpAlfredo.jpg';
import FriedChickenBbqImage from 'images/mealCardGallery/FriedChickenAndHoneyBbq.jpg';
import GoatCheeseCranberrySaladImage from 'images/mealCardGallery/GoatCheeseCranberrySalad.jpg';
import ItalianSausageRigatoniImage from 'images/mealCardGallery/italian-sausage-rigatoni.jpg';
import OrangeGingerPorkNoodlesImage from 'images/mealCardGallery/orange-ginger-pork-noodles.jpg';
import PretzelCrustedChickenImage from 'images/mealCardGallery/PretzelCrustedChicken.jpg';
import RedPepperPestoBeefSirloinImage from 'images/mealCardGallery/RedPepperPestoBeefSirloin.jpg';
import RoastedPepperSausagePenneImage from 'images/mealCardGallery/RoastedPepperAndSausagePenne.jpg';
import RoastedRedPepperChickenImage from 'images/mealCardGallery/RoastedRedPepperChicken.jpg';
import SalmonBltSaladImage from 'images/mealCardGallery/SalmonAndBltSalad.jpg';
import SalmonPiccataButterImage from 'images/mealCardGallery/SalmonPiccataButter.jpg';
import SpicySausageGrainBowlImage from 'images/mealCardGallery/SpicySausageGrainBowl.jpg';
import ChickenGrainBowlImage from 'images/mealCardGallery/TuscanHerbChickenGrainBowl.jpg';
import ShrimpPenneImage from 'images/mealCardGallery/TuscanShrimpPenne.jpg';

export const GALLERY_BUTTONS = {
  GREATEST_HITS: 'greatestHits',
  EASY_PREP_MEALS: 'easyPrepMeals',
  FAMILY_MEALS: 'familyMeals',
  GREATEST_FAMILY_HITS: 'greatestFamilyHits',
  FRESH_START: 'freshStart',
  TEMPO_MEALS: 'tempoMeals',
};

export const STANDARD_GALLERY_BUTTONS = [
  GALLERY_BUTTONS.GREATEST_HITS,
  GALLERY_BUTTONS.EASY_PREP_MEALS,
  GALLERY_BUTTONS.FAMILY_MEALS,
  GALLERY_BUTTONS.FRESH_START,
];

export const PARTNERSHIP_GALLERY_BUTTONS = [
  GALLERY_BUTTONS.EASY_PREP_MEALS,
  GALLERY_BUTTONS.FAMILY_MEALS,
  GALLERY_BUTTONS.FRESH_START,
];

export const mealCardHeading = {
  standard: 'A Look At Our Menu',
  family: 'A Look at Our Family-Friendly Meals',
  tempo: 'A Look At Our Menu',
};

const familyMealsArray = [
  {
    title: 'One-Pot Creamy Italian Sausage Rigatoni',
    subtitle: 'with fire roasted tomatoes and kale',
    url: ItalianSausageRigatoniImage,
  },
  {
    title: 'Classic Brown Sugar-Glazed Meatloaf',
    subtitle: 'with cheddar mashed potatoes and peas',
    url: BrownSugarGlazedMeatloafImage,
  },
  {
    title: 'One-Pan Chicken and Vegetable Fajitas',
    subtitle: 'with guacamole and queso fresco',
    url: ChickenAndVegetableFajitasImage,
  },
  {
    title: 'One-Pan Orange Ginger Sesame Pork Noodles',
    subtitle: 'with green beans',
    url: OrangeGingerPorkNoodlesImage,
  },
];

export const mealCardData = {
  greatestHits: [
    {
      title: 'Bacon Jalapeno Popper Steak Sandwich',
      subtitle: 'with potato wedges and chipotle pepper jam',
      url: SteakSandwichImage,
    },
    {
      title: 'Tuscan-Style Shrimp Penne',
      subtitle: 'with mushrooms and tomatoes',
      url: ShrimpPenneImage,
    },
    {
      title: 'Fried Chicken and Honey Gold BBQ Sauce',
      subtitle: 'with cordon bleu potatoes',
      url: FriedChickenBbqImage,
    },
    {
      title: 'French Onion Butternut Squash Risotto',
      subtitle: 'with goat cheese and mushrooms',
      url: ButternutSquashRisottoImage,
    },
  ],
  easyPrepMeals: [
    {
      title: 'Mustard Pretzel Crusted Chicken',
      subtitle: 'with garlic and herb white cheddar mashed potatoes',
      url: PretzelCrustedChickenImage,
    },
    {
      title: 'Florentine Shrimp Alfredo',
      subtitle: 'with lemon',
      url: ShrimpAlfredoImage,
    },
    {
      title: 'Roasted Red Pepper and Italian Sausage Penne',
      subtitle: 'with goat cheese',
      url: RoastedPepperSausagePenneImage,
    },
    {
      title: 'Tuscan Herb Chicken Grain Bowl',
      subtitle: 'with spinach and roasted tomatoes',
      url: ChickenGrainBowlImage,
    },
  ],
  familyMeals: familyMealsArray,
  greatestFamilyHits: familyMealsArray,
  freshStart: [
    {
      title: 'Creamy Sun-Dried Tomato Chicken',
      subtitle: 'with parmesan green beans',
      url: CreamyTomatoChickenImage,
    },
    {
      title: 'Salmon and BLT Salad',
      subtitle: 'with Tuscan herb butter',
      url: SalmonBltSaladImage,
    },
    {
      title: 'Garlic-Herb Goat Cheese and Cranberry Salad',
      subtitle: 'with creamy chimichurri dressing',
      url: GoatCheeseCranberrySaladImage,
    },
    {
      title: 'Salmon with Lemon Piccata Butter',
      subtitle: 'with zucchini noodle salad',
      url: SalmonPiccataButterImage,
    },
  ],
  tempoMeals: [
    {
      url: RedPepperPestoBeefSirloinImage,
      title: 'Red Pepper Pesto Beef Sirloin',
      subtitle: 'with kale, butternut squash, and cauliflower grits',
      name: 'Red Pepper Pesto Beef Sirloin',
    },
    {
      url: CaribbeanStyleJerkTofuImage,
      title: 'Caribbean-Style Jerk Tofu',
      subtitle: 'with roasted plantains, red beans, and brown rice',
      name: 'Caribbean-Style Jerk Tofu',
    },
    {
      url: SpicySausageGrainBowlImage,
      title: 'Spicy Sausage Grain Bowl',
      subtitle: 'with farro, butternut squash, and kale',
      name: 'Spicy Sausage Grain Bowl',
    },
    {
      url: RoastedRedPepperChickenImage,
      title: 'Roasted Red Pepper Chicken',
      subtitle: 'with squash, onions, and whole wheat penne',
      name: 'Roasted Red Pepper Chicken',
    },
  ],
};
